<div class="table fixTableHead" #print_table>
<table class="table table-fixed table-hover">
	<thead>
	<tr>
		<th>ID#</th>
		<th>Description</th>
	</tr>
	</thead>
	<tbody>
	<tr *ngFor="let auth of data">
		<td>{{ auth.taxcatid }}</td>
		<td>{{ auth.taxcatname }}</td>
	</tr>
	</tbody>
</table>
</div>
